import React from 'react';
import { WorkflowWrapper } from '../../../../Workflow/Workflow.styles';
import { Card } from '../../../../CommonComponents/OPL/Card/Card';
import { ProfileWrapper } from '../../../Profile.styles';
import { ProfilePageHeader } from '../../../components/ProfilePageHeader/ProfilePageHeader';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';

export enum WrapperVariant {
  Workflow,
  EstatePlanning,
}

const Header = () => {
  return (
    <ProfilePageHeader
      title="Your Household Information"
      description="Please include information about your household."
    />
  );
};

interface Props {
  variant?: WrapperVariant;
  children: React.ReactNode;
}

export const Wrapper = ({ variant, children }: Props) => {
  if (variant === WrapperVariant.EstatePlanning) {
    return (
      <WorkflowWrapper>
        <Header />

        {children}
      </WorkflowWrapper>
    );
  }

  if (variant === WrapperVariant.Workflow) {
    return (
      <WorkflowWrapper>
        <Card p="32">
          <Header />

          {children}
        </Card>
      </WorkflowWrapper>
    );
  }

  return (
    <Box css="overflow-x: auto">
      <ProfileWrapper hasStickyFooter>
        <Header />

        <Card p="32">{children}</Card>
      </ProfileWrapper>
    </Box>
  );
};
